import { render, staticRenderFns } from "./copyUpdate.vue?vue&type=template&id=54cbecfd&scoped=true&"
import script from "./copyUpdate.vue?vue&type=script&lang=js&"
export * from "./copyUpdate.vue?vue&type=script&lang=js&"
import style0 from "./copyUpdate.vue?vue&type=style&index=0&id=54cbecfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbecfd",
  null
  
)

export default component.exports